import { CardTypes, IPaymentMethod } from 'state/payment/types';

function sortPaymentMethods(methods: IPaymentMethod[]): IPaymentMethod[] {
  let sortedMethods: IPaymentMethod[] = [];

  //Static for now, refactor to get from Sanity
  const paymentMethodListTypeOrder = [
    'CARD',
    'PAYPAL',
    'SODEXO_VOUCHER',
    'SODEXO',
    'CHEQUE_GOURMET_VOUCHER',
    'CHEQUE_GOURMET',
    'CASH',
  ];

  paymentMethodListTypeOrder.forEach(typeOrder => {
    const filteredMethodByType = filterMethodByType(typeOrder, methods);
    sortedMethods = [...sortedMethods, ...filteredMethodByType];
  });

  const lastMethods = methods.filter(
    m => !sortedMethods.find(s => s.accountIdentifier === m.accountIdentifier)
  );
  return [...sortedMethods, ...lastMethods];
}

function filterMethodByType(typeOrder: string, paymentMethods: IPaymentMethod[]): IPaymentMethod[] {
  switch (typeOrder) {
    case 'CARD':
      return paymentMethods.filter(
        p => !!p.credit && p.credit.cardType in CardTypes && p.credit.cardType !== CardTypes.PAYPAL
      );
    case 'SODEXO':
      return paymentMethods.filter(
        p => p?.transient && p?.sodexo && p.accountIdentifier === typeOrder
      );
    case 'CHEQUE_GOURMET':
      return paymentMethods.filter(
        p => p?.transient && p?.chequeGourmet && p.accountIdentifier === typeOrder
      );
    case 'SODEXO_VOUCHER':
      return paymentMethods.filter(
        p => !p?.transient && p?.sodexo && p.accountIdentifier === typeOrder
      );
    case 'CHEQUE_GOURMET_VOUCHER':
      return paymentMethods.filter(
        p => !p?.transient && p?.chequeGourmet && p.accountIdentifier === typeOrder
      );
    case 'CASH':
      return paymentMethods.filter(p => p?.cash && p.accountIdentifier === typeOrder);
    case 'PAYPAL':
      return paymentMethods.filter(p => p?.paypal && p.accountIdentifier === typeOrder);
    default:
      return [];
  }
}

export default sortPaymentMethods;
